// Mirrors the backend billing contact order (cap-backend
// src/utilities/cmpMemberBillingContact.ts). Keep the two in step.
// Order: Billing Contact, Main Company Contact, Primary Contact, admin login.

type Contact = { email?: string | null; name?: string | null };

export type MemberInvoiceRecipient = {
  email: string;
  name: string;
  sourceLabel: string;
};

const isValidEmail = (value?: string | null): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || "").trim().toLowerCase());

export const getMemberInvoiceRecipient = ({
  administrator,
  billing,
  mainCompany,
  primary,
}: {
  administrator: Contact;
  billing: Contact;
  mainCompany: Contact;
  primary: Contact;
}): MemberInvoiceRecipient | null => {
  const candidates: Array<Contact & { sourceLabel: string }> = [
    { ...billing, sourceLabel: "Billing Contact" },
    { ...mainCompany, sourceLabel: "Main Company Contact" },
    { ...primary, sourceLabel: "Primary Contact" },
    { ...administrator, sourceLabel: "Administrator login" },
  ];
  const chosen = candidates.find((candidate) => isValidEmail(candidate.email));
  if (!chosen) return null;
  const email = (chosen.email || "").trim().toLowerCase();
  const owner = candidates.find((candidate) =>
    (candidate.name || "").trim() &&
    (candidate.email || "").trim().toLowerCase() === email);
  return {
    email,
    name: (owner?.name || chosen.name || "").trim(),
    sourceLabel: chosen.sourceLabel,
  };
};
